import { makeStyles } from '@mui/styles';
import { drawerWidth } from '../../constants';

const useStyles = makeStyles(
  (theme) => ({
    wrapper: {
      position: 'fixed',
      top: 0,
      left: `${drawerWidth}px`,
      width: `calc(100% - ${drawerWidth}px)`,
      backgroundColor: '#E3E8F9',
      display: 'flex',
      justifyContent: 'center',
      zIndex: '100',

      [theme.breakpoints.down('md')]: {
        position: 'relative',
        width: 'calc(100% + 40px)', // to offset the margin
        left: 0,
        margin: '-20px -20px 16px -20px',
        // top: '50px',
      },
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      // flexWrap: 'wrap',
      gap: '16px',
      padding: '8px 60px',
      height: '56px',
      width: '100%',
      maxWidth: '1566px',

      [theme.breakpoints.down('md')]: {
        padding: '10px 16px',
        height: 'fit-content',
      },
    },
    contentContainer: {
      alignItems: 'center',
      display: 'flex',
      gap: '16px',
      marginRight: 'auto',
    },
  }),
  { name: 'DisabledBanner' },
);

export default useStyles;
